import { z } from 'zod';

/** `statusCode` is null when no response arrived (DNS, TLS, timeout) */
export const zodTestSendContactPointResultSchema = z.object({
  errorCode: z.string().nullable(),
  failureClass: z.string().nullable(),
  latencyMs: z.number(),
  message: z.string(),
  ok: z.boolean(),
  responseExcerpt: z.string().nullable(),
  statusCode: z.number().nullable(),
});

export type TestSendContactPointResult = z.infer<
  typeof zodTestSendContactPointResultSchema
>;
